import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-3 mb-2" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { computed, ref, watch } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { CodesDocument, CodeType } from '@/gql/graphql';
import {
  BAlert,
  BButton,
  BCollapse,
  BForm,
  BFormGroup,
  BFormInput,
  BPagination,
  BSpinner,
} from 'bootstrap-vue-next';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import CodeList from '@/components/code/CodeList.vue';
import CodeGenerator from '@/components/code/CodeGenerator.vue';
import { deepParseDates } from '@/utils/date-utils';
import { PAGING_ITEMS_PER_PAGE } from '@/constants';

// Filtering and paging state

export default /*@__PURE__*/_defineComponent({
  __name: 'AdminCodesListView',
  setup(__props) {

const codePattern = ref('');
const pagingPageCurrent = ref(1);
const pagingItemsPerPage = ref(PAGING_ITEMS_PER_PAGE);
const pagingTotalRows = computed(() => {
  return codesQueryResult.value?.codes?.total || 0;
});

const showCodeGenerator = ref<boolean>(false);

const codes = computed<CodeType[]>(() => {
  return (
    codesQueryResult.value?.codes?.codes
      ?.filter((code) => code && code !== null)
      .map((code) => ({ ...(deepParseDates(code) as CodeType) })) || []
  );
});

// --- Query Codes with Kits, Coupons and Licenses ---
const {
  result: codesQueryResult,
  loading: codesQueryInProgress,
  error: codesQueryError,
  refetch: refetchCodes,
} = useQuery(CodesDocument, {
  acrossOrganizations: true,
  codePattern: codePattern.value,
  page: pagingPageCurrent.value,
  pagingPageCurrent: pagingPageCurrent.value,
  pagingItemsPerPage: pagingItemsPerPage.value,
});

function requestRefetchCodes() {
  refetchCodes({
    acrossOrganizations: true,
    codePattern: codePattern.value,
    page: pagingPageCurrent.value,
    pagingPageCurrent: pagingPageCurrent.value,
    pagingItemsPerPage: pagingItemsPerPage.value,
  })
    ?.catch((err) => {
      console.error('Refetch failed:', err);
    })
    .then(() => {
      console.log('refetched');
    });
}

function onSearchRequested() {
  if (pagingPageCurrent.value !== 1) {
    pagingPageCurrent.value = 1;
  } else {
    requestRefetchCodes();
  }
}

function clearFilter() {
  codePattern.value = '';
  pagingPageCurrent.value = 1;

  requestRefetchCodes();
}

function codesGenerationSuccess() {
  requestRefetchCodes();
  showCodeGenerator.value = false;
}

watch(pagingPageCurrent, (newPage) => {
  console.debug('page changed to', newPage);
  requestRefetchCodes();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", null, [
      _createVNode(_unref(FontAwesomeIcon), { icon: ['fas', 'ticket'] }),
      _cache[6] || (_cache[6] = _createTextVNode(" Kits and coupons", -1))
    ]),
    _cache[13] || (_cache[13] = _createElementVNode("hr", null, null, -1)),
    _cache[14] || (_cache[14] = _createElementVNode("p", null, " Browse the kits and coupons identified by the associated code. Check codes association with organizations and inspect kit and coupon details. ", -1)),
    _createElementVNode("div", null, [
      _createVNode(_unref(BButton), {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showCodeGenerator.value = !showCodeGenerator.value)),
        variant: "outline-dark",
        class: "mb-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(FontAwesomeIcon), { icon: ['fas', 'ticket'] }),
          _cache[7] || (_cache[7] = _createTextVNode(" Generate new codes", -1))
        ]),
        _: 1
      }),
      _createVNode(_unref(BCollapse), {
        modelValue: showCodeGenerator.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showCodeGenerator).value = $event)),
        id: "code-generator"
      }, {
        default: _withCtx(() => [
          _createVNode(CodeGenerator, {
            onCodesGenerated: codesGenerationSuccess,
            class: "mt-3"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "mt-4" }, "List of existing codes", -1)),
      _createVNode(_unref(BAlert), {
        modelValue: _unref(codesQueryError),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(codesQueryError) ? (codesQueryError).value = $event : null)),
        variant: "danger",
        dismissible: "",
        class: "mt-3"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(codesQueryError)) + " ", 1),
          _createVNode(_unref(BButton), {
            onClick: requestRefetchCodes,
            variant: "outline-dark",
            class: "btn-sm"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(FontAwesomeIcon), { icon: ['fas', 'sync'] }),
              _cache[8] || (_cache[8] = _createTextVNode(" Retry", -1))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(BForm), {
          class: "d-flex flex-row align-items-end flex-wrap gap-2",
          onSubmit: _withModifiers(onSearchRequested, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BFormGroup), {
              label: "Code",
              "label-for": "code-pattern"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BFormInput), {
                  id: "code-pattern",
                  type: "text",
                  modelValue: codePattern.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((codePattern).value = $event)),
                  placeholder: "e.g. X32D-C384"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BButton), {
              variant: "outline-secondary",
              onClick: clearFilter
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(FontAwesomeIcon), { icon: "trash" }),
                _cache[9] || (_cache[9] = _createTextVNode(" Clear filter ", -1))
              ]),
              _: 1
            }),
            _createVNode(_unref(BButton), {
              variant: "outline-dark",
              type: "submit",
              disabled: _unref(codesQueryInProgress)
            }, {
              default: _withCtx(() => [
                (_unref(codesQueryInProgress))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                      _createVNode(_unref(BSpinner), {
                        small: "",
                        label: ""
                      }),
                      _cache[10] || (_cache[10] = _createTextVNode(" Searching ", -1))
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_3, [
                      _createVNode(_unref(FontAwesomeIcon), { icon: "magnifying-glass" }),
                      _cache[11] || (_cache[11] = _createTextVNode(" Refresh ", -1))
                    ]))
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      (pagingTotalRows.value > pagingItemsPerPage.value)
        ? (_openBlock(), _createBlock(_unref(BPagination), {
            key: 0,
            modelValue: pagingPageCurrent.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((pagingPageCurrent).value = $event)),
            "total-rows": pagingTotalRows.value,
            "per-page": pagingItemsPerPage.value,
            pills: "",
            size: "sm"
          }, null, 8, ["modelValue", "total-rows", "per-page"]))
        : _createCommentVNode("", true),
      _createVNode(CodeList, {
        codes: codes.value,
        loading: _unref(codesQueryInProgress)
      }, null, 8, ["codes", "loading"]),
      (pagingTotalRows.value > pagingItemsPerPage.value)
        ? (_openBlock(), _createBlock(_unref(BPagination), {
            key: 1,
            modelValue: pagingPageCurrent.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((pagingPageCurrent).value = $event)),
            "total-rows": pagingTotalRows.value,
            "per-page": pagingItemsPerPage.value,
            pills: "",
            size: "sm"
          }, null, 8, ["modelValue", "total-rows", "per-page"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})